var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDotNet(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 260,
    height: 260,
    viewBox: "0 0 260 260",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_22_73)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 36,
    width: 180,
    height: 180,
    rx: 32,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40.5,
    y: 36.5,
    width: 179,
    height: 179,
    rx: 31.5,
    stroke: "#D9D9D9"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M164.884 128.937C164.884 128.762 164.836 128.638 164.739 128.557C164.631 128.469 164.444 128.422 164.185 128.422H163.811V129.458H164.262C164.678 129.458 164.884 129.284 164.884 128.937ZM165.466 131.095H164.953L164.626 130.367C164.459 130.002 164.282 129.819 164.087 129.819H163.811V131.095H163.388V128.059H164.236C164.612 128.059 164.895 128.141 165.09 128.313C165.254 128.46 165.336 128.65 165.336 128.885C165.336 129.094 165.269 129.27 165.134 129.416C165.002 129.564 164.813 129.663 164.571 129.715V129.728C164.739 129.768 164.907 129.954 165.07 130.289L165.466 131.097V131.095ZM166.404 129.607C166.404 129.01 166.202 128.505 165.799 128.105C165.394 127.705 164.9 127.505 164.318 127.505C163.717 127.505 163.217 127.705 162.82 128.109C162.424 128.514 162.226 129.015 162.226 129.607C162.226 130.213 162.432 130.719 162.84 131.122C163.243 131.525 163.737 131.724 164.318 131.724C164.895 131.724 165.389 131.524 165.795 131.115C166.202 130.714 166.404 130.209 166.404 129.607ZM166.689 129.594C166.689 130.264 166.46 130.827 166.001 131.28C165.542 131.736 164.979 131.963 164.306 131.963C163.628 131.963 163.066 131.739 162.618 131.3C162.171 130.853 161.948 130.293 161.948 129.612C161.948 128.947 162.175 128.388 162.63 127.928C163.084 127.47 163.65 127.241 164.326 127.241C164.989 127.241 165.545 127.46 165.996 127.896C166.458 128.344 166.689 128.909 166.689 129.594Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M102.331 138.061H100.872V129.639C100.872 128.973 100.916 128.164 100.993 127.208H100.96C100.824 127.767 100.699 128.172 100.588 128.422L96.3464 138.061H95.6356L91.3854 128.492C91.2656 128.225 91.1403 127.795 91.0135 127.208H90.9819C91.0267 127.71 91.0517 128.525 91.0517 129.655V138.061H89.6448V125.519H91.5699L95.3858 134.265C95.6737 134.924 95.8597 135.425 95.9501 135.767H96.0107C96.259 135.081 96.4565 134.567 96.6063 134.228L100.504 125.519H102.331V138.061H102.331Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M106.821 138.061H105.403V129.104H106.821V138.061ZM107.066 125.893C107.066 126.157 106.974 126.378 106.791 126.559C106.612 126.739 106.39 126.831 106.13 126.831C105.876 126.831 105.656 126.743 105.475 126.568C105.294 126.393 105.205 126.169 105.205 125.893C105.205 125.634 105.295 125.414 105.475 125.234C105.656 125.055 105.876 124.969 106.13 124.969C106.39 124.969 106.612 125.055 106.791 125.234C106.974 125.414 107.066 125.634 107.066 125.893Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M115.685 137.646C115.003 138.068 114.191 138.277 113.251 138.277C111.978 138.277 110.952 137.851 110.169 136.999C109.409 136.173 109.026 135.106 109.026 133.799C109.026 132.332 109.442 131.144 110.281 130.241C111.115 129.337 112.238 128.885 113.649 128.885C114.421 128.885 115.105 129.038 115.704 129.34V130.812C115.041 130.342 114.34 130.11 113.588 130.11C112.683 130.11 111.948 130.428 111.377 131.064C110.783 131.714 110.482 132.584 110.482 133.669C110.482 134.711 110.757 135.536 111.303 136.145C111.851 136.75 112.58 137.054 113.5 137.054C114.276 137.054 115.003 136.797 115.685 136.284V137.646Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M122.469 130.557C122.219 130.363 121.859 130.268 121.383 130.268C120.805 130.268 120.32 130.529 119.927 131.055C119.481 131.642 119.259 132.455 119.259 133.494V138.061H117.837V129.104H119.259V130.95H119.293C119.502 130.297 119.824 129.794 120.256 129.437C120.659 129.112 121.114 128.948 121.616 128.948C121.995 128.948 122.276 128.989 122.469 129.07V130.556L122.469 130.557Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M130.392 133.599C130.392 132.452 130.136 131.576 129.622 130.975C129.124 130.398 128.428 130.109 127.531 130.109C126.647 130.109 125.938 130.401 125.408 130.985C124.847 131.609 124.568 132.49 124.568 133.634C124.568 134.706 124.834 135.547 125.372 136.147C125.907 136.751 126.628 137.053 127.531 137.053C128.466 137.053 129.181 136.746 129.672 136.136C130.152 135.538 130.392 134.694 130.392 133.599ZM131.85 133.548C131.85 134.975 131.451 136.122 130.654 136.981C129.854 137.844 128.778 138.276 127.426 138.276C126.093 138.276 125.032 137.844 124.253 136.981C123.491 136.15 123.108 135.052 123.108 133.686C123.108 132.128 123.541 130.927 124.41 130.074C125.213 129.282 126.287 128.884 127.633 128.884C128.958 128.884 129.993 129.3 130.738 130.125C131.477 130.955 131.85 132.096 131.85 133.548Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M138.901 135.665C138.901 136.398 138.629 137.005 138.085 137.49C137.491 138.014 136.675 138.276 135.648 138.276C134.807 138.276 134.07 138.099 133.445 137.737V136.196C134.141 136.766 134.909 137.054 135.753 137.054C136.879 137.054 137.443 136.635 137.443 135.802C137.443 135.452 137.319 135.162 137.07 134.938C136.819 134.709 136.334 134.435 135.612 134.115C134.868 133.786 134.338 133.449 134.025 133.099C133.65 132.684 133.461 132.145 133.461 131.482C133.461 130.738 133.756 130.119 134.338 129.626C134.922 129.132 135.673 128.885 136.594 128.885C137.3 128.885 137.932 129.024 138.493 129.304V130.748C137.907 130.322 137.237 130.109 136.477 130.109C136.007 130.109 135.628 130.227 135.347 130.458C135.062 130.693 134.919 130.994 134.919 131.36C134.919 131.757 135.039 132.066 135.276 132.286C135.487 132.49 135.934 132.739 136.609 133.03C137.367 133.35 137.915 133.682 138.249 134.022C138.682 134.452 138.901 134.999 138.901 135.665Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M147.589 133.599C147.589 132.452 147.333 131.576 146.818 130.975C146.321 130.398 145.623 130.109 144.728 130.109C143.844 130.109 143.135 130.401 142.602 130.985C142.043 131.609 141.764 132.49 141.764 133.634C141.764 134.706 142.031 135.547 142.564 136.147C143.105 136.751 143.826 137.053 144.728 137.053C145.664 137.053 146.378 136.746 146.869 136.136C147.349 135.538 147.589 134.694 147.589 133.599ZM149.05 133.548C149.05 134.975 148.647 136.122 147.849 136.981C147.053 137.844 145.977 138.276 144.624 138.276C143.29 138.276 142.228 137.844 141.45 136.981C140.688 136.15 140.305 135.052 140.305 133.686C140.305 132.128 140.741 130.927 141.605 130.074C142.408 129.282 143.484 128.884 144.831 128.884C146.156 128.884 147.189 129.3 147.933 130.125C148.674 130.955 149.05 132.096 149.05 133.548Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M155.315 126.06C155.035 125.904 154.724 125.825 154.371 125.825C153.375 125.825 152.881 126.457 152.881 127.723V129.104H154.963V130.318H152.881V138.061H151.458V130.318H149.948V129.104H151.458V127.652C151.458 126.666 151.758 125.893 152.366 125.335C152.888 124.851 153.526 124.61 154.285 124.61C154.724 124.61 155.067 124.663 155.315 124.766V126.06Z",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M160.926 137.971C160.591 138.165 160.143 138.261 159.59 138.261C158.04 138.261 157.265 137.38 157.265 135.618V130.32H155.742V129.103H157.265V126.918C157.719 126.774 158.192 126.616 158.69 126.453V129.103H160.926V130.32H158.69V135.374C158.69 135.975 158.788 136.404 158.991 136.653C159.197 136.91 159.533 137.037 160.007 137.037C160.36 137.037 160.666 136.941 160.926 136.748V137.971Z",
    fill: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M84.0712 173.019C84.0712 173.721 83.8229 174.328 83.3209 174.841C82.8207 175.352 82.2135 175.609 81.5011 175.609C80.805 175.609 80.2126 175.352 79.7273 174.841C79.2418 174.328 79 173.721 79 173.019C79 172.297 79.2418 171.688 79.7273 171.184C80.2126 170.678 80.805 170.427 81.5011 170.427C82.2135 170.427 82.8207 170.681 83.3209 171.194C83.8229 171.706 84.0712 172.315 84.0712 173.019Z",
    fill: "black"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M115.903 175.082H111.267L94.4354 148.869C94.0421 148.239 93.7031 147.553 93.4153 146.805H93.2769C93.3967 147.507 93.458 149.014 93.458 151.322V175.082H89.6356V142.196H94.5967L110.924 167.995C111.574 169.018 112.018 169.752 112.244 170.193H112.335C112.183 169.247 112.105 167.635 112.105 165.358V142.196H115.904V175.082H115.903Z",
    fill: "black"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M140.408 175.082H123.124V142.196H139.658V145.68H126.944V156.62H138.725V160.106H126.944V171.595H140.408V175.082Z",
    fill: "black"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M166.624 145.681H157.231V175.082H153.41V145.681H143.998V142.195H166.624V145.681Z",
    fill: "black"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M114.607 85.3941C118.295 96.7653 119.692 117.051 130.474 117.051C131.295 117.051 132.125 116.97 132.957 116.81C123.155 114.505 121.994 94.4406 116.012 84.0499C115.543 84.4797 115.078 84.9277 114.607 85.3941Z",
    fill: "url(#paint0_linear_22_73)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M116.012 84.0499C121.994 94.4406 123.155 114.505 132.957 116.81C133.727 116.667 134.499 116.452 135.272 116.179C126.474 111.832 124.042 92.3482 117.25 82.968C116.838 83.3133 116.425 83.675 116.012 84.0499Z",
    fill: "url(#paint1_linear_22_73)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M124.63 77.8705C123.811 77.8705 122.98 77.9514 122.146 78.1112C119.964 78.526 117.747 79.4734 115.513 80.907C116.123 81.5143 116.704 82.2095 117.25 82.9679C119.523 81.0663 121.78 79.6609 124.03 78.8163C124.874 78.501 125.715 78.2638 126.559 78.1078C125.95 77.9517 125.308 77.8705 124.63 77.8705Z",
    fill: "#14559A"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M142.14 112.172C143.04 111.45 143.942 110.652 144.845 109.781C141.099 98.4628 139.758 77.8872 128.899 77.8872C128.123 77.8872 127.34 77.9602 126.558 78.1062C136.449 80.587 137.716 102.288 142.14 112.172Z",
    fill: "url(#paint2_linear_22_73)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M126.558 78.107C125.95 77.9511 125.308 77.8698 124.63 77.8698L128.9 77.8856C128.123 77.8856 127.34 77.9586 126.558 78.1064",
    fill: "#3092C4"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M141.951 114.576C141.526 114.168 141.123 113.72 140.727 113.242C138.9 114.547 137.08 115.536 135.272 116.179C135.915 116.496 136.59 116.732 137.306 116.878C137.86 116.992 138.434 117.051 139.038 117.051C141.067 117.051 142.671 116.808 144.037 116.148C143.285 115.738 142.596 115.207 141.951 114.576Z",
    fill: "#1969BC"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M124.029 78.8182C132.888 83.4908 133.658 104.65 140.727 113.242C141.201 112.906 141.67 112.549 142.139 112.172C137.714 102.288 136.449 80.5852 126.56 78.1062C125.716 78.2655 124.873 78.5013 124.029 78.8182Z",
    fill: "url(#paint3_linear_22_73)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M117.25 82.9681C124.042 92.3482 126.474 111.832 135.272 116.179C137.081 115.536 138.9 114.547 140.727 113.242C133.658 104.65 132.888 83.4908 124.029 78.8182C121.78 79.6611 119.522 81.0665 117.25 82.9681Z",
    fill: "url(#paint4_linear_22_73)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M110.261 85.1202C109.197 87.5479 108.109 90.7387 106.794 94.9036C109.409 91.1883 112.015 87.9876 114.607 85.3941C114.25 84.2873 113.867 83.2668 113.454 82.3574C112.394 83.1755 111.326 84.0965 110.261 85.1202Z",
    fill: "url(#paint5_linear_22_73)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M114.398 81.6575C114.085 81.8831 113.771 82.1138 113.455 82.3577C113.868 83.267 114.249 84.2876 114.607 85.3943C115.077 84.9296 115.544 84.48 116.012 84.0502C115.51 83.1807 114.977 82.3776 114.398 81.6575Z",
    fill: "#2B74B1"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M115.513 80.907C115.141 81.1444 114.771 81.3949 114.397 81.657C114.977 82.3772 115.51 83.1803 116.013 84.0515C116.426 83.6748 116.839 83.3114 117.251 82.9679C116.704 82.2097 116.123 81.5143 115.513 80.907Z",
    fill: "#125A9E"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M175.939 77.0046C170.929 96.4899 160.464 112.141 151.69 116.086H151.674C151.514 116.159 151.356 116.226 151.2 116.29C151.178 116.304 151.159 116.305 151.142 116.313C151.096 116.332 151.053 116.346 151.007 116.365C150.986 116.378 150.966 116.382 150.947 116.39C150.873 116.417 150.8 116.439 150.728 116.469C150.696 116.482 150.667 116.49 150.637 116.5C150.604 116.514 150.566 116.526 150.529 116.536C150.496 116.549 150.461 116.559 150.423 116.573C150.392 116.587 150.359 116.592 150.33 116.605C150.265 116.624 150.206 116.64 150.142 116.662C150.116 116.662 150.091 116.677 150.063 116.684C150.023 116.697 149.979 116.706 149.936 116.718C149.907 116.731 149.882 116.736 149.851 116.742C149.806 116.755 149.757 116.768 149.712 116.778C149.653 116.791 149.601 116.803 149.545 116.815C149.941 116.963 150.354 117.038 150.8 117.038C159.119 117.038 167.508 102.003 181.387 77H175.937L175.939 77.0046Z",
    fill: "url(#paint6_linear_22_73)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M104.988 78.6612C104.993 78.6612 105 78.6481 105.003 78.6481C105.009 78.6481 105.019 78.6481 105.023 78.635H105.033C105.079 78.6192 105.122 78.6004 105.168 78.5832C105.18 78.5832 105.186 78.5832 105.194 78.57C105.206 78.57 105.218 78.5569 105.229 78.5552C105.278 78.5395 105.328 78.5207 105.374 78.5035H105.382C105.492 78.4703 105.594 78.4292 105.701 78.3907C105.716 78.3907 105.731 78.3775 105.749 78.3775C105.793 78.3631 105.839 78.3469 105.885 78.3364C105.907 78.3232 105.928 78.3232 105.948 78.3163C105.995 78.3019 106.041 78.2857 106.086 78.2752C106.106 78.2752 106.124 78.262 106.138 78.2607C106.292 78.2182 106.443 78.1784 106.596 78.1412C106.617 78.1412 106.635 78.1281 106.658 78.1268C106.703 78.1136 106.744 78.1067 106.792 78.1001C106.812 78.087 106.835 78.087 106.858 78.0801C106.902 78.0669 106.945 78.0656 106.992 78.0548H107.024C107.116 78.036 107.21 78.0203 107.302 78.003H107.358C107.402 77.9898 107.442 77.9885 107.486 77.9803C107.511 77.9803 107.536 77.9672 107.559 77.9672C107.6 77.9672 107.641 77.954 107.682 77.9484C107.703 77.9484 107.725 77.9484 107.749 77.9353C107.846 77.9221 107.947 77.9169 108.049 77.9087C107.761 77.8807 107.465 77.8622 107.164 77.8622C97.7945 77.8622 84.886 95.3928 79.071 118.096H80.1916C82.0526 114.749 83.7244 111.583 85.253 108.611C89.3254 92.5306 97.6201 81.5641 104.988 78.6587",
    fill: "url(#paint7_linear_22_73)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M110.261 85.1202C111.326 84.0965 112.394 83.1755 113.454 82.3576C113.212 81.8233 112.962 81.3288 112.693 80.8757C111.836 81.9244 111.053 83.3083 110.261 85.1202Z",
    fill: "#0D82CA"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M111.031 78.7941C111.643 79.3118 112.191 80.0237 112.693 80.8766C112.851 80.6808 113.011 80.4999 113.177 80.3307C112.481 79.6753 111.729 79.1377 110.913 78.7328C110.946 78.7512 110.979 78.766 111.013 78.7806C111.013 78.7806 111.026 78.7937 111.031 78.7937",
    fill: "#0D82CA"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M85.2526 108.613C93.7957 92.0114 97.8435 81.5045 104.988 78.6605C97.6213 81.5677 89.325 92.5341 85.2526 108.613Z",
    fill: "url(#paint8_linear_22_73)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M113.176 80.3302C113.01 80.5012 112.852 80.6804 112.693 80.8762C112.961 81.3292 113.211 81.822 113.454 82.358C113.77 82.1141 114.085 81.8834 114.397 81.6577C114.011 81.1765 113.602 80.7302 113.176 80.3302Z",
    fill: "#127BCA"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M89.1309 118.023C89.0782 118.036 89.0256 118.036 88.9762 118.042H88.9466C88.9021 118.042 88.856 118.055 88.8149 118.055H88.7935C88.6866 118.068 88.5812 118.068 88.4792 118.076H88.4463C97.0931 117.832 101.045 113.466 103.007 107.135C104.498 102.334 105.722 98.2904 106.795 94.8971C103.173 100.038 99.5349 106.165 95.8771 113.03C94.1132 116.339 91.4311 117.721 89.1308 118.016",
    fill: "url(#paint9_linear_22_73)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M89.1309 118.02C91.4312 117.724 94.1133 116.344 95.8772 113.033C99.535 106.17 103.175 100.041 106.793 94.9003C108.109 90.7337 109.195 87.5446 110.262 85.1169C103.05 92.0396 95.8097 103.55 89.1309 118.016",
    fill: "url(#paint10_linear_22_73)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M85.2522 108.613C83.7236 111.585 82.0519 114.751 80.1908 118.098H83.4505C83.8816 114.774 84.4937 111.605 85.2522 108.615",
    fill: "#05A1E6"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M107.749 77.9438C107.723 77.9438 107.703 77.9569 107.68 77.9569C107.64 77.9701 107.599 77.9701 107.558 77.9743C107.534 77.9743 107.511 77.9743 107.486 77.9875C107.441 78.0006 107.4 78.0019 107.357 78.0102C107.338 78.0102 107.318 78.0102 107.302 78.0233C107.208 78.0391 107.116 78.0565 107.023 78.0724H106.992C106.944 78.0856 106.902 78.0925 106.857 78.099C106.834 78.1122 106.811 78.1122 106.79 78.1174C106.745 78.1306 106.701 78.1362 106.658 78.1441C106.635 78.1572 106.617 78.1572 106.595 78.1585C106.442 78.1957 106.291 78.2355 106.138 78.278C106.122 78.278 106.105 78.2912 106.085 78.2938C106.039 78.3069 105.995 78.3204 105.947 78.3349C105.927 78.3481 105.904 78.3481 105.885 78.3533C105.839 78.3665 105.793 78.38 105.748 78.3945C105.73 78.3945 105.715 78.4076 105.699 78.4076C105.593 78.4475 105.49 78.4873 105.381 78.5205C105.335 78.535 105.286 78.5537 105.236 78.5709C105.216 78.5841 105.198 78.587 105.176 78.5962C105.129 78.6107 105.083 78.6294 105.041 78.6467C105.024 78.6598 105.008 78.6611 104.996 78.668C97.8518 81.5121 93.804 92.0189 85.2609 108.621C84.5023 111.611 83.8886 114.78 83.4591 118.103H83.9165C85.2049 118.103 85.5686 118.09 87.0511 118.09H87.1268H87.3473H87.423H87.4444H87.5201H87.5629H87.5925H87.6518H87.836H88.0203H88.175H88.2161H88.4876C88.5896 118.077 88.6949 118.077 88.8018 118.069H88.8216C88.8661 118.069 88.9105 118.056 88.9532 118.056H88.9844C89.0321 118.056 89.0864 118.043 89.1391 118.037C95.8179 103.571 103.058 92.0604 110.27 85.1377C111.063 83.3257 111.845 81.9418 112.7 80.8948C112.2 80.042 111.652 79.3285 111.04 78.8106C111.04 78.8106 111.023 78.8106 111.022 78.7975C110.987 78.783 110.955 78.7656 110.92 78.7484C110.885 78.7296 110.856 78.7152 110.82 78.6966C110.788 78.6835 110.752 78.666 110.721 78.6488C110.678 78.6357 110.644 78.6169 110.606 78.5997C110.574 78.5865 110.547 78.573 110.515 78.5599C110.451 78.5346 110.387 78.5081 110.326 78.4802C110.298 78.4671 110.272 78.4602 110.245 78.4497C110.201 78.4335 110.15 78.4125 110.104 78.3926C110.081 78.3794 110.054 78.3768 110.028 78.3673C109.961 78.3446 109.895 78.3208 109.832 78.2995H109.816C109.74 78.2742 109.666 78.2558 109.589 78.2345C109.571 78.2213 109.556 78.2213 109.538 78.2187C109.47 78.2 109.411 78.1815 109.347 78.1643C109.331 78.1643 109.316 78.1511 109.303 78.1511C109.148 78.11 108.988 78.0768 108.827 78.0463C108.811 78.0463 108.794 78.0331 108.778 78.0331C108.709 78.02 108.641 78.0078 108.572 77.9999C108.556 77.9868 108.546 77.9868 108.531 77.9868C108.449 77.9736 108.368 77.9641 108.288 77.9549H108.245C108.179 77.9418 108.118 77.9404 108.057 77.9335C107.953 77.9467 107.855 77.9523 107.758 77.9615",
    fill: "url(#paint11_linear_22_73)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M156.368 87.7917C154.725 93.1016 153.393 97.4822 152.235 101.086C156.745 94.8273 161.188 86.9537 165.418 77.8674C160.484 79.4304 157.851 83.008 156.368 87.7917Z",
    fill: "url(#paint12_linear_22_73)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M152.378 115.755C152.148 115.873 151.918 115.985 151.69 116.086C160.464 112.141 170.929 96.4899 175.939 77.0046H174.924C163.413 97.741 159.71 111.623 152.378 115.755Z",
    fill: "url(#paint13_linear_22_73)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M146.649 114.012C148.558 111.663 150.113 107.669 152.236 101.086C149.787 104.478 147.322 107.394 144.856 109.771C144.856 109.784 144.856 109.784 144.843 109.793C145.381 111.419 145.972 112.854 146.645 114.012",
    fill: "#079AE1"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M146.649 114.012C145.999 114.812 145.312 115.421 144.546 115.873C144.379 115.971 144.209 116.063 144.036 116.148C144.844 116.588 145.726 116.881 146.713 116.999C146.858 117.014 147.001 117.027 147.151 117.038H147.178C147.245 117.038 147.316 117.038 147.388 117.051H147.417H147.633H147.865H147.937H148.102C148.128 117.051 148.156 117.051 148.182 117.038C148.233 117.038 148.287 117.038 148.34 117.025H148.359H148.418C148.472 117.025 148.531 117.011 148.589 117.006H148.602C148.619 117.006 148.638 116.993 148.655 116.993C148.715 116.98 148.778 116.974 148.837 116.965H148.891C148.959 116.952 149.028 116.943 149.097 116.93H149.11H149.13C149.268 116.904 149.403 116.877 149.54 116.843C148.408 116.424 147.46 115.439 146.644 114.035",
    fill: "#1969BC"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M130.474 117.051C131.295 117.051 132.125 116.97 132.957 116.809C133.727 116.668 134.499 116.452 135.272 116.18C135.916 116.497 136.591 116.732 137.305 116.878C137.859 116.992 138.435 117.051 139.039 117.051H130.474Z",
    fill: "#1E5CB3"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M139.039 117.051C141.066 117.051 142.672 116.809 144.036 116.148C144.844 116.588 145.726 116.882 146.713 117C146.858 117.014 147.001 117.027 147.151 117.038H147.178C147.245 117.038 147.316 117.038 147.388 117.051H147.418H147.634H139.033L139.039 117.051Z",
    fill: "#1E5CB3"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M147.639 117.051H147.873H147.945H148.108C148.136 117.051 148.162 117.051 148.188 117.038C148.24 117.038 148.294 117.038 148.348 117.025H148.365H148.426C148.48 117.025 148.539 117.011 148.596 117.006H148.61C148.627 117.006 148.644 116.993 148.661 116.993C148.722 116.98 148.785 116.975 148.844 116.965C148.864 116.965 148.879 116.965 148.9 116.952C148.968 116.939 149.037 116.932 149.106 116.919H149.119H149.139C149.277 116.892 149.412 116.866 149.549 116.831C149.945 116.979 150.358 117.054 150.804 117.054L147.642 117.067L147.639 117.051Z",
    fill: "#1D60B5"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M144.848 109.793V109.78C143.945 110.651 143.043 111.449 142.143 112.171C141.672 112.547 141.203 112.904 140.729 113.241C141.126 113.719 141.529 114.167 141.954 114.575C142.599 115.206 143.288 115.737 144.04 116.146C144.211 116.062 144.382 115.969 144.548 115.871C145.315 115.42 146.003 114.811 146.653 114.011C145.98 112.853 145.389 111.417 144.851 109.791",
    fill: "#175FAB"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M171.709 77.0046H167.441H167.016H166.615H166.599C166.323 77.0177 166.054 77.0273 165.789 77.0444C165.664 77.315 165.536 77.5855 165.413 77.8576C161.182 86.9439 156.739 94.8175 152.229 101.076C150.108 107.659 148.552 111.653 146.643 114.003C147.459 115.406 148.409 116.394 149.537 116.812C149.57 116.799 149.597 116.799 149.626 116.792H149.645C149.664 116.792 149.686 116.778 149.707 116.778C149.753 116.765 149.802 116.757 149.849 116.743C149.878 116.73 149.903 116.728 149.933 116.719C149.975 116.706 150.02 116.696 150.059 116.685C150.086 116.672 150.112 116.668 150.138 116.663C150.204 116.641 150.263 116.626 150.326 116.606C150.355 116.593 150.387 116.582 150.42 116.574C150.456 116.561 150.492 116.551 150.525 116.535C150.563 116.522 150.601 116.515 150.633 116.501C150.663 116.488 150.694 116.479 150.722 116.468C150.796 116.441 150.869 116.418 150.943 116.389C150.963 116.389 150.982 116.371 151.004 116.367C151.048 116.348 151.094 116.333 151.139 116.313C151.155 116.3 151.175 116.299 151.196 116.292C151.351 116.227 151.51 116.161 151.67 116.088H151.687C151.914 115.987 152.144 115.874 152.373 115.756C159.707 111.625 163.409 97.7426 174.92 77.0062H171.705L171.709 77.0046Z",
    fill: "url(#paint14_linear_22_73)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M108.049 77.9158C108.067 77.9158 108.083 77.9158 108.101 77.9289C108.146 77.9289 108.19 77.9289 108.235 77.9434H108.279C108.36 77.9565 108.44 77.9634 108.523 77.9752C108.538 77.9752 108.551 77.9752 108.564 77.9884C108.631 78.0015 108.7 78.0124 108.77 78.0229C108.784 78.0229 108.804 78.0361 108.821 78.0361C108.979 78.0679 109.14 78.1011 109.294 78.1423C109.309 78.1423 109.324 78.1554 109.337 78.1554C109.403 78.1712 109.462 78.1912 109.528 78.2098C109.548 78.2098 109.563 78.223 109.581 78.2259C109.658 78.246 109.731 78.2658 109.806 78.291C109.809 78.291 109.814 78.291 109.823 78.3041C109.887 78.3238 109.953 78.3492 110.02 78.3718C110.047 78.3849 110.071 78.3905 110.096 78.3971C110.142 78.4172 110.193 78.4369 110.237 78.4555C110.264 78.4555 110.29 78.4739 110.318 78.4835C110.379 78.5114 110.443 78.5365 110.506 78.5631C110.539 78.5762 110.566 78.591 110.598 78.6029C110.634 78.6216 110.672 78.6388 110.711 78.652C110.744 78.6678 110.78 78.6852 110.812 78.6998C110.846 78.7185 110.879 78.733 110.912 78.7516C111.728 79.1565 112.48 79.6958 113.176 80.3496C113.433 80.0774 113.701 79.8334 113.979 79.6144C112.457 78.5259 110.733 77.9053 108.743 77.9053C108.513 77.9053 108.283 77.9185 108.049 77.9359",
    fill: "#7DCBEC"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M113.176 80.3302C113.602 80.7301 114.011 81.1765 114.397 81.6577C114.771 81.3956 115.141 81.1433 115.513 80.9077C115.026 80.4165 114.512 79.9751 113.978 79.5951C113.7 79.8125 113.433 80.0581 113.176 80.3302Z",
    fill: "#5EC5ED"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M108.048 77.9155C108.282 77.8956 108.512 77.8873 108.743 77.8873C110.732 77.8873 112.457 78.5079 113.979 79.5947C115.585 78.317 117.526 77.8707 120.223 77.8707H107.163C107.464 77.8707 107.759 77.8889 108.048 77.9155Z",
    fill: "url(#paint15_linear_22_73)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M120.223 77.8707C117.526 77.8707 115.585 78.317 113.979 79.5947C114.512 79.9747 115.025 80.4161 115.512 80.9072C117.748 79.4736 119.963 78.5245 122.147 78.1096C122.979 77.952 123.81 77.8707 124.63 77.8707H120.223Z",
    fill: "url(#paint16_linear_22_73)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M152.235 101.09C153.395 97.4822 154.723 93.1033 156.37 87.7917C157.854 83.0063 160.482 79.4288 165.417 77.8674C165.547 77.6002 165.67 77.3247 165.797 77.0542C157.752 77.5405 153.992 81.6671 152.1 87.7785C148.791 98.4479 146.787 105.364 144.857 109.771C147.322 107.395 149.787 104.478 152.235 101.09Z",
    fill: "url(#paint17_linear_22_73)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M164.037 114.209H163.126V117.066H162.754V114.209H161.839V113.869H164.037V114.209Z",
    fill: "black"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M167.77 117.065H167.4V114.918C167.4 114.749 167.413 114.542 167.43 114.298C167.392 114.444 167.36 114.545 167.331 114.61L166.252 117.065H166.071L164.988 114.628C164.957 114.56 164.925 114.45 164.891 114.298H164.878C164.891 114.427 164.895 114.635 164.895 114.923V117.065H164.54V113.868H165.03L166.002 116.1C166.076 116.267 166.122 116.397 166.146 116.483H166.16C166.224 116.307 166.277 116.176 166.313 116.09L167.305 113.868H167.772V117.065H167.77Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_22_73",
    x: 0,
    y: 0,
    width: 260,
    height: 260,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0367917 0 0 0 0 0.0348958 0 0 0 0 0.0484375 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_22_73"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_22_73",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_22_73",
    x1: 1032.05,
    y1: -559.993,
    x2: 1032.05,
    y2: 4361.77,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0994DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.350006,
    stopColor: "#66CEF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.846161,
    stopColor: "#127BCA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#127BCA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_22_73",
    x1: 1079.02,
    y1: -577.496,
    x2: 1079.02,
    y2: 4469.69,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E76BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.360001,
    stopColor: "#36AEE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.846161,
    stopColor: "#00ADEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00ADEF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_22_73",
    x1: 1040.91,
    y1: 3880.82,
    x2: 1040.91,
    y2: -135.157,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C63B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#33BDF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#33BDF2",
    stopOpacity: 0.419608
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_22_73",
    x1: 1029.53,
    y1: -607.576,
    x2: 1029.53,
    y2: 4632.71,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#166AB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.399994,
    stopColor: "#36AEE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.846161,
    stopColor: "#0798DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0798DD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_22_73",
    x1: 1291.07,
    y1: -650.515,
    x2: 1291.07,
    y2: 4921.84,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#124379"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.389999,
    stopColor: "#1487CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.780228,
    stopColor: "#165197"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#165197"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_22_73",
    x1: 106.797,
    y1: 709.673,
    x2: 888.052,
    y2: 709.673,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#33BDF2",
    stopOpacity: 0.698039
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1DACD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_22_73",
    x1: 1741.97,
    y1: 3868.02,
    x2: 1741.97,
    y2: -44.0972,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#136AB4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#59CAF5",
    stopOpacity: 0.54902
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#59CAF5",
    stopOpacity: 0.235294
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_22_73",
    x1: 79.049,
    y1: 2089.52,
    x2: 2976.83,
    y2: 2089.52,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#05A1E6",
    stopOpacity: 0.247059
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#05A1E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_22_73",
    x1: 1071.99,
    y1: 3802.16,
    x2: 1071.99,
    y2: -203.533,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#318ED5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#38A7E4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_22_73",
    x1: 1005.84,
    y1: 2208.83,
    x2: 1005.84,
    y2: -1684.92,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#05A1E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#05A1E6",
    stopOpacity: 0.54902
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_22_73",
    x1: 1145.67,
    y1: 3375.74,
    x2: 1145.67,
    y2: 85.4523,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1959A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#05A1E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.917587,
    stopColor: "#7EC5EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7EC5EA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_22_73",
    x1: 1832.2,
    y1: 3876.71,
    x2: 709.306,
    y2: 473.805,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#165096"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D82CA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_22_73",
    x1: 811.331,
    y1: 1865.67,
    x2: 811.331,
    y2: 1.27007,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#05A1E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.873627,
    stopColor: "#0495D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0495D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_22_73",
    x1: 1734.25,
    y1: -85.6324,
    x2: -13.0375,
    y2: 3761.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#38A7E4",
    stopOpacity: 0.329412
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.961533,
    stopColor: "#0E88D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E88D3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_22_73",
    x1: 1560.98,
    y1: 65.2306,
    x2: 1560.98,
    y2: 4132.63,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#168CD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#1C87CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#154B8D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_22_73",
    x1: 324.921,
    y1: -274.806,
    x2: 342.693,
    y2: 151.761,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#97D6EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703293,
    stopColor: "#55C1EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#55C1EA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_22_73",
    x1: 187.365,
    y1: 61.7758,
    x2: 267.664,
    y2: -389.858,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7ACCEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3FB7ED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_22_73",
    x1: 1191.78,
    y1: 285.226,
    x2: 1191.78,
    y2: 4263.55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1DA7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#37ABE7",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDotNet);
export default __webpack_public_path__ + "static/media/dot-net.079d193729c87a64dacca9b8bbbe9fa6.svg";
export { ForwardRef as ReactComponent };